<template class="layout-toolbar">
  <v-app-bar :dense="false" app>
    <div><h3 class="app-primary-color">More Than Just a Rental Store</h3></div>
    <v-spacer />
    <slot name="widget-header-action">
      <v-autocomplete
        :items="parentCompaniesList"
        :loading="isLoaderCust"
        :menu-props="{ auto: true, bottom: true, 'offset-y': true }"
        @change="updateCompany"
        align-end
        auto
        autocomplete="off"
        class="inputField company-dropdown"
        dense
        item-id="id"
        item-text="name"
        item-value="id"
        label="Customer"
        outlined
        return-object
        style="max-width: 200px"
        v-if="isCustomer"
        v-model="companySelected"
      ></v-autocomplete>
      <v-autocomplete
        :items="parentCompaniesList"
        :loading="isLoaderCust"
        :menu-props="{ auto: true, bottom: true, 'offset-y': true }"
        :search-input.sync="searchCustomer"
        @change="updateCompany"
        align-end
        auto
        autocomplete="off"
        class="inputField company-dropdown"
        dense
        hide-no-data
        hide-selected
        item-text="name"
        item-value="id"
        label="Customer"
        outlined
        return-object
        style="max-width: 200px"
        v-if="!isCustomer"
        v-model="companySelected"
      ></v-autocomplete>

      <v-btn @click="onReloadCustomers()" icon v-if="!isCustomer">
        <v-icon>mdi-cached</v-icon>
      </v-btn>
      <!--  @change="updateCompany" -->
      <!-- <v-checkbox
        class="mt-5 pr-4"
        label="Set as default"
        :disabled="disabled || isMapRoute"
        v-model="defaultCustomer"
        @click="setDefaultCustomer()"
      ></v-checkbox>
      <div
        v-if="
          currentRoute !== '/appsheettools/audit_tool' && currentRoute !== '/finance-report' && currentRoute !== '/appsheettools/data_integrity_report_dashboard'
          && currentRoute !== '/appsheettools/data_integrity_report'
        "
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="green" class="mr-4" v-on="on" v-bind="attrs"
              >mdi-information</v-icon
            >
          </template>
          <span>Page content is driven based on the company selected.</span>
        </v-tooltip>
      </div>
      <div v-else>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-4 ml-0"
              dark
              v-bind="attrs"
              v-on="on"
              color="#E1AD01"
              >mdi-alert</v-icon
            >
          </template>
          <span>Company controls are managed seperately on this page.</span>
        </v-tooltip>
      </div> -->
      <!-- <MapCompanyIcon></MapCompanyIcon> -->
      <!-- <slot name="widget-header-action">
        <v-autocomplete
          :menu-props="{ auto: true, bottom: true, 'offset-y': true }"
          autocomplete="off"
          outlined
          dense
          :disabled="isMapRoute"
          class="inputField company-dropdown"
          :items="parentCompaniesList"
          v-model="companySelected"
          return-object
          item-text="name"
          item-id="id"
          item-value="id"
          label="Company"
          align-end
          auto
          @change="updateCompany"
        ></v-autocomplete>
      </slot> -->
    </slot>
    <div class="d-flex align-right" v-if="!isCustomer">
      <CustomerDialog :iscustombtn="true" />
      <Notification></Notification>
    </div>
    <profile />
    <v-dialog v-model="customerNavigateDialog" width="350" persistent>
      <v-card v-if="roles != 'Customer'">
        <v-card-title class="headline justify-center grey lighten-2 pa-1 ma-0">
          Confirmation
        </v-card-title>

        <v-card-text>
          <div class="text-center mt-4">
            <b
              >SMS customer is not linked to this company. Are you sure you want
              to link ?</b
            >
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary-btn" @click="redirectSMSCustomerUpdatePage()">
            Yes
          </v-btn>
          <v-btn class="secondary-btn" @click="closeSMSCustomerDialog()">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-title class="headline justify-center grey lighten-2 pa-1 ma-0">
          Confirmation
        </v-card-title>

        <v-card-text>
          <div class="text-center mt-4">
            <b>Currently not available please contact Birch Administrator</b>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary-btn" @click="goToDefaultPage()"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>
<style>
.select-type-report {
  width: 150px !important;
}
.cust_styling {
  background: #363636;
  color: white !important;
}
.cust_styling a {
  background: #363636;
  color: white !important;
}
.cust_styling a:hover {
  text-decoration: underline;
}
.cust_styling .v-list-item {
  /* padding: 0px !important; */
  min-height: 30px !important;
  justify-content: center;
}
.v-list.cust_styling.v-sheet.theme--light {
  padding: 0 !important;
}
.single_btn {
  pointer-events: none !important;
}
.btn-align {
  margin-right: 25px;
  font-size: 12px !important;
  text-transform: capitalize;
}
.plus-icon {
  font-size: 12px !important;
}
.v-expansion-panel::before {
  box-shadow: none !important;
}
.align-right {
  text-align: right;
}
.textspacing {
  margin-top: 0;
}
.company-dropdown {
  height: 40px;
  max-width: 250px;
}
/* .company-logo-mini {
  width:150px !important;
  height: 48px !important;
}
.company-logo-mini img {
  width: auto;
  height: 24px;
  cursor: pointer;
} */
/* Apply styles starting from medium devices and up to extra large devices*/

@media (min-width: 1261px) and(max-width: 1920px) {
  .lo {
    margin: 0 2% !important;
  }
}
</style>
<script>
import { mapGetters } from "vuex";
// import Breadcrumbs from "../widget/AppBreadcrumbs.vue";
import Profile from "../widget/AppProfile.vue";
import Notification from "../widget/AppNotification.vue";
import { hasAccess } from "../../config/admin.route.config";
import rules from "../../utils/rules";
import api from "@/api/api.service";
// import companyapi from "@/api/company.service";
import EventBus from "../../utils/EventBus";
// import Customer from "@/components/Common/Customer.vue";
import CustomerDialog from "@/components/Common/CustomerDialog";
import telematicsService from "../../api/telematics.service";
// import EventBus from "../utils/EventBus";
export default {
  name: "TheLayoutToolbar",
  components: {
    // Breadcrumbs,
    Profile,
    Notification,
    CustomerDialog,
  },
  data: () => ({
    reportitems: [{ name: "Report" }, { name: "Integration" }],
    // reportvalue: "",
    repValue: "",
    NewReports: {},
    items: [
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me 2" },
    ],
    userdialog: false,
    loading: false,
    valid: true,
    details: "",
    rules: rules,
    // companyName: "",
    trackunitToken: "",
    TrackunitTokenError: "",
    name: "",
    email: "",
    phone: "",
    trackunitnumber: "",
    clientId: "",
    clientSecret: "",
    userName: "",
    password: "",
    showclientSecret: false,
    showpassword: false,
    userRole: "",
    isAccess: {
      reportAbug: true,
      reportRequest: true,
    },
    openedPanel: null,
    isCustomer: false,
    parentCompaniesList: [],
    companySelected: {},
    defaultCustomer: true,
    disabled: true,
    layouttoolbarKey: 0,
    currentRoute: null,
    isMapRoute: false,
    isLoaderCust: true,
    searchCustomer: null,
    showArrows: true,
    customerNavigateDialog: false,
    isCallMap: false,
  }),
  props: ["isNavigationExpanded"],
  watch: {
    deep: true,
    immediate: true,
    $route: function (from, to) {
      this.currentRoute = from.path;
      if (from.fullPath != to.fullPath) {
        this.handleRouter(true);
      } else if (from.fullPath == "/") {
        // this.isCallMap = false;
        this.handleRouter(true);
      }
      if (
        this.currentRoute == "/appsheettools/audit_tool" ||
        this.currentRoute == "/finance-report" ||
        this.currentRoute == "/appsheettools/data_integrity_report_dashboard" ||
        this.currentRoute == "/appsheettools/data_integrity_report"
      ) {
        this.isMapRoute = true;
      } else {
        this.isMapRoute = false;
      }
    },
    searchCustomer(val) {
      // Items have already been loaded
      //if (this.parentCompaniesList.length > 1) return;

      // Items have already been requested
      //if (this.isLoaderCust) return;

      //check entered text is not undefined and enter search text is multiples of 2 characters
      if (val != undefined && val != "All" && val.length % 3 == 0) {
        this.searchCustomers(val);
      }
    },
    isNavigationExpanded(val) {
      console.log(val);
      this.rt();
    },
  },
  computed: {
    ...mapGetters([
      "toolbarDense",
      "navbarShow",
      "roles",
      "reportvalue",
      "reportId",
      "ToolsapiToken",
      "companyName",
      "basicCustomers",
      "companyNameDropdown",
      "companyIdDropdown",
      "smsCustomerLinkingId",
      "smsBirchLinkingId",
      "smsCustomerId",
      "smsUserId",
      "storeReserveType",
    ]),
    toggleNavbarIcon() {
      return this.navbarShow
        ? "mdi-format-indent-decrease"
        : "mdi-format-indent-increase";
    },
  },
  created() {
    EventBus.$on("customer-got-triggered", this.onCustomerTriggered);
    EventBus.$on("updateSMSCustomer", this.onUpdateSMSCustomer);
  },
  beforeDestroy() {
    EventBus.$off("customer-got-triggered", this.onCustomerTriggered);
    EventBus.$off("updateSMSCustomer", this.onUpdateSMSCustomer);
  },

  mounted() {
    this.handleCustomers();
    this.userId = this.$store.getters.userId;
    this.isCustomer = this.roles == "Customer" ? true : false;
    this.isAccess = hasAccess.dashboard[this.roles]
      ? hasAccess.dashboard[this.roles]
      : this.isAccess;
    // this.CompanyList();
    //Check if reportID exists in store

    // if (this.$store.getters.reportId != "") {
    //   //set the dropdown value to the store reportID.
    //   this.companySelected.id = this.$store.getters.reportId;
    //   //check if dropdown change value is default company value and enable checkbox based on that
    //   if (this.companySelected.id != this.$store.getters.referenceId) {
    //     this.disabled = false;
    //     this.defaultCustomer = false;
    //   } else {
    //     //disable checkbox as it is a default company
    //     this.disabled = true;
    //     this.defaultCustomer = true;
    //   }
    // }
    // this.handleRouter(false);
    if (
      this.companyNameDropdown != "" &&
      this.companyNameDropdown != "All" &&
      this.companyNameDropdown != undefined &&
      this.companyIdDropdown != null
    ) {
      this.companySelected = {
        name: this.companyNameDropdown,
        id: this.companyIdDropdown,
        smsCustomerId: this.smsCustomerLinkingId,
        BirchCustomerID: this.smsBirchLinkingId,
      };
    } else {
      this.$store.dispatch("setSMSCustomerLinkingId", "  0000");
      //  this.$store.dispatch("setSMSBirchLinkingId", this.smsUserId);
      this.$store.dispatch("setSMSBirchLinkingId", this.smsCustomerId);
      this.companySelected = {
        name: "All",
        id: null,
        smsCustomerId: "  0000",
        BirchCustomerID: this.smsUserId,
      };
    }
    this.rt();
  },
  methods: {
    onCustomerTriggered() {
      (this.rules = rules), (this.userdialog = true);
    },
    onUpdateSMSCustomer(value) {
      if (value) {
        this.handleCustomers();
        this.onReloadNew();
        if (this.companyNameDropdown == "" && this.roles != "Customer") {
          this.companySelected = {
            name: "All",
            id: null,
            smsCustomerId: "  0000",
            BirchCustomerID: this.smsUserId,
          };
        } else {
          this.companySelected = {
            name: this.companyNameDropdown,
            id: this.companyIdDropdown,
            smsCustomerId: this.smsCustomerLinkingId,
            BirchCustomerID: this.smsBirchLinkingId,
          };
        }
      }
    },
    goToDefaultPage() {
      this.$router.push({ path: "/" });
      this.closeSMSCustomerDialog();
    },
    handleRouter(fromRouteChange) {
      if (fromRouteChange) {
        if (this.$route.path == "/") {
          // if (!this.isCallMap) {
          EventBus.$emit("call-map");
          // } else {
          //   this.isCallMap = false;
          // }
        }
      }
    },
    rt() {
      // var buttonRt = document.getElementById("sideRight");
      // var buttonLt = document.getElementById("sideLeft");
      // eslint-disable-next-line no-debugger

      if (window.screen.width <= 1366) {
        this.showArrows = false;

        // buttonRt.style.display = "block ";
        // buttonLt.style.display = "block ";

        // console.log(window.screen.width);

        //   buttonRt.onclick = function () {
        //     document.getElementById("container").scrollLeft += 180;
        //   };
        //   buttonLt.onclick = function () {
        //     document.getElementById("container").scrollLeft -= 180;
        //   };
        // }
      } else if (window.screen.width > 1367) {
        // console.log(window.screen.width);
        this.showArrows = true;
        // buttonRt.style.display = "none";
        // buttonLt.style.display = "none";
      }
    },
    buttonRight() {
      document.getElementById("container").scrollLeft += 180;
    },
    buttonLeft() {
      document.getElementById("container").scrollLeft -= 180;
    },
    sR() {
      document.getElementById("container").scrollLeft += 180;
    },
    sL() {
      document.getElementById("container").scrollLeft -= 180;
    },

    scrollLeft: function () {
      const menu = this.$refs.menu;
      menu.scrollTo({
        left: (this.scrollAmount += 200),
        behavior: "smooth",
      });
    },

    scrollRight: function () {
      const menu = this.$refs.menu;
      menu.scrollTo({
        left: (this.scrollAmount -= 200),
        behavior: "smooth",
      });
    },
    async handleCustomers() {
      if (this.basicCustomers.length == 0) {
        let finaldata = [];
        if (this.roles == "Customer") {
          const response = await telematicsService.getBasicCustomers();
          if (response.isSuccess) {
            finaldata = response.data.filter((e) => e.name !== "");
            this.parentCompaniesList = finaldata;
            this.companySelected = this.parentCompaniesList[0];
            this.$store.dispatch(
              "setCompanyNameDropdown",
              this.companySelected.name
            );
            this.$store.dispatch(
              "setCompanyIdDropdown",
              this.companySelected.id
            );
            this.$store.dispatch(
              "setSMSCustomerLinkingId",
              this.companySelected.smsCustomerId
            );
            this.$store.dispatch(
              "setSMSBirchLinkingId",
              this.companySelected.birchCustomerId
            );
            // console.log("data", this.companySelected.birchCustomerId);

            // finaldata.unshift({ id: null, name: "All",smsCustomerId: "  0000", BirchCustomerID: this.smsUserId });
          } else {
            this.parentCompaniesList = [];
            // finaldata.unshift({ id: null, name: "All",smsCustomerId: "  0000", BirchCustomerID: this.smsUserId });
          }
        } else {
          finaldata.unshift({
            id: null,
            name: "All",
            smsCustomerId: "  0000",
            BirchCustomerID: this.smsUserId,
          });
        }
        this.$store
          .dispatch("setReloadedBasicCustomers", finaldata)
          .then(() => {
            this.getBasicCustomers();
          });
      } else {
        this.isLoaderCust = false;
        this.parentCompaniesList = this.basicCustomers;
      }
      //  emit eventbus after login and customers loaded
      if (this.$route.path == "/") {
        EventBus.$emit("call-map");
        // this.isCallMap = true;
      }
    },
    async searchCustomers(value) {
      try {
        this.isLoaderCust = true;
        const response = await telematicsService.searchBasicCustomers(value);
        if (response.isSuccess) {
          let finaldata = response.data.filter((e) => e.name !== "");

          // Add All option to the finaldata
          finaldata.unshift({
            id: null,
            name: "All",
            smsCustomerId: "  0000",
            BirchCustomerID: this.smsUserId,
          });

          this.parentCompaniesList = finaldata;

          //update the basic customers list to the store with the search results
          this.$store.dispatch("setReloadedBasicCustomers", finaldata);
          this.isLoaderCust = false;
        } else {
          this.isLoaderCust = false;
          this.parentCompaniesList = [
            {
              id: null,
              name: "All",
              smsCustomerId: "  0000",
              BirchCustomerID: this.smsUserId,
            },
          ];
        }
      } catch (err) {
        this.isLoaderCust = false;
        // console.log(err);
      }
    },
    async onReloadCustomers() {
      try {
        this.isLoaderCust = true;
        let response = await telematicsService.updateReloadCustomers();
        if (response) {
          setTimeout(() => {
            this.parentCompaniesList = response.data;
            this.isLoaderCust = false;
            //update the reloaded customers to the store
            this.$store.dispatch("setReloadedBasicCustomers", response.data);
            this.$toast.success("Customers loaded successfully");
          }, 10000);
        }
      } catch (err) {
        // console.log(err);
        this.isCustomersLoading = false;
        this.customers = [];
      }
    },
    getBasicCustomers() {
      this.isLoaderCust = true;
      this.parentCompaniesList = this.basicCustomers;
      this.isLoaderCust = false;
    },
    toggleNavbar() {
      this.$store.dispatch("NavbarToggle");
    },
    // async CompanyList() {
    //   try {
    //     let _this = this;
    //     let response = await companyapi.getAllCustomers();
    //     if (response) {
    //       _this.parentCompaniesList = response.data;

    //       //set first item in dropdown in case if user doesnot have default customer
    //       if (
    //         (this.$store.getters.referenceId == "" ||
    //           this.$store.getters.referenceId == null ||
    //           this.$store.getters.referenceId == undefined) &&
    //         (this.$store.getters.reportId == "" ||
    //           this.$store.getters.reportId == null ||
    //           this.$store.getters.reportId == undefined)
    //       ) {
    //         _this.companySelected.id = _this.parentCompaniesList[0].id;
    //         _this.companySelected.name = _this.parentCompaniesList[0].name;

    //         this.$store.dispatch("setReportId", this.companySelected.id);
    //         this.$store.dispatch("setCompanyName", this.companySelected.name);

    //         //enable checkbox
    //         this.disabled = false;
    //         this.defaultCustomer = false;
    //       }
    //     }
    //   } catch (error) {
    //     //this.$toast.error("Unable to load the data" + error);
    //   }
    // },
    updateCompany() {
      window.localStorage.setItem("masterItems", JSON.stringify([]));
      //Update CRID to Store
      if (
        this.companySelected &&
        this.companySelected.name &&
        this.companySelected.name
      ) {
        this.$store.dispatch(
          "setCompanyNameDropdown",
          this.companySelected.name
        );
        this.$store.dispatch("setCompanyIdDropdown", this.companySelected.id);
        this.$store.dispatch(
          "setSMSCustomerLinkingId",
          this.companySelected.smsCustomerId
        );
        this.$store.dispatch(
          "setSMSBirchLinkingId",
          this.companySelected.birchCustomerId
        );
        if (
          (this.storeReserveType != "" || this.storeReserveType == "") &&
          this.$route.path == "/create-planning-sheet"
        ) {
          this.$router.push({ name: "View Current Sheets" });
        }
        if (this.roles == "Customer") {
          if (this.$route.path == "/") {
            EventBus.$emit("call-map");
          } else {
            this.$router.go();
          }
        } else {
          this.$router.go();
        }
      }
    },
    async SaveOnBoardingReport() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let payload = {
          userId: this.userId,
          companyName: this.companyName,
          trackUnitToken: this.trackunitToken,
          trackUnitAccountNumber: this.trackunitnumber,
          name: this.name,
          email: this.email,
          phone: this.phone,
          // details: this.details,
          iris_ClientID: this.clientId,
          iris_ClientSecret: this.clientSecret,
          iris_Username: this.userName,
          iris_Password: this.password,
        };
        try {
          let apiResponse = await api.createCustomerOnboarding(payload);
          if (apiResponse) {
            this.loading = false;
            this.userdialog = false;
            this.$refs.form.reset();
            this.$toast.success(apiResponse.systemMessage);

            // if (this.$route.name == "CustomerOnboardingList") {
            //   this.$router.go();
            // } else {
            //   this.$router
            //     .push({
            //       path: "/customer-onboarding/list",
            //     })
            //     .catch(() => {});
            // }
          }
        } catch (err) {
          this.loading = false;
          if (err.response.status == 400) {
            this.TrackunitTokenError = err.response.data;
            this.$toast.error(err.response.data);
          } else this.$toast.error("Unable to create customer" + err);
        }
      }
    },
    ClearDialog() {
      this.openedPanel = null;
      this.userdialog = false;
      this.$refs.form.reset();
      (this.companyName = ""),
        (this.trackunitToken = ""),
        (this.name = ""),
        (this.email = ""),
        (this.phone = ""),
        (this.trackunitnumber = "");
      this.clientId = "";
      this.clientSecret = "";
      this.userName = "";
      this.password = "";
    },
    async setDefaultCustomer() {
      let payload = {
        userId: this.$store.getters.userId,
        customerReferenceId: this.companySelected.id,
      };
      try {
        let apiResult = await api.setdefaultCustomer(payload);
        if (apiResult) {
          this.disabled = true;
          this.$toast.success(apiResult.systemMessage);
        }
      } catch (err) {
        this.$toast.error("Unable to save as default customer");
      }
    },
    async onReloadNew() {
      try {
        this.isLoaderCust = true;
        let response = await telematicsService.updateReloadCustomers();
        if (response) {
          setTimeout(() => {
            this.parentCompaniesList = response.data;
            this.parentCompaniesList.unshift({ id: null, name: "All" });
            this.isLoaderCust = false;
            //update the reloaded customers to the store
            this.$store.dispatch("setReloadedBasicCustomers", response.data);
            this.$toast.success("Customers loaded successfully");
          }, 10000);
          this.$store.dispatch(
            "setSMSCustomerLinkingId",
            this.companySelected.smsCustomerId
          );
          this.$store.dispatch(
            "setSMSBirchLinkingId",
            this.companySelected.birchCustomerId
          );
        }
      } catch (err) {
        // console.log(err);
        this.isCustomersLoading = false;
        this.customers = [];
      }
    },
    closeSMSCustomerDialog() {
      this.customerNavigateDialog = false;
    },
    redirectSMSCustomerUpdatePage() {
      this.closeSMSCustomerDialog();
      this.$router
        .push({
          name: "View Customer Details",
          params: { id: this.companyIdDropdown },
        })
        .catch(() => {});
    },
  },
};
</script>
